/* 商品ページの「再入荷お知らせ」(入荷お知らせ)
 *
 * snippets/product-restock.liquid が出力したブロックを、
 *   1. 「売り切れ／カートに追加する」ボタン(.product-form__buttons)の直後・カートのフォームの中へ移動する
 *      (お気に入りボタンがフォーム末尾に差し込まれるので、その上に置くため)
 *   2. 選択中のバリエーションが「売り切れ」または「取り寄せ中」のときだけ表示する
 *   3. ボタンで Dawn標準のモーダル(<modal-dialog>)を開き、「登録する」で商品DBの受付APIへ POST する
 *   4. 登録後は商品ページ側に完了表示(取消リンク付き)を出す
 *
 * ⚠️ <modal-dialog> は Dawn の global.js が <body> 直下へ移動するので、必ず id で探す(root の中には無い)。
 * バリエーションの切り替えは Dawn の variant-change イベント(pubsub.js)を聞く。
 * 念のため variant-selects / variant-radios の change も聞いて少し待ってから読み直す。
 *
 * 送るもの: store / handle / sku / email / variant / product_title / visitor_id / notify_on / website(ハニーポット)
 *   visitor_id は GA4 の _ga クッキー(例 GA1.1.583018360.1788523954)。商品DB側で番号だけにする。
 *   notify_on は 取り寄せ中なら 'stock'(在庫が入ったときだけ知らせる)、売り切れなら 'any'。
 */
(function () {
  var root = document.querySelector('.restock');
  if (!root) return;

  var variants = {};
  try {
    variants = JSON.parse(root.querySelector('.restock__variants').textContent) || {};
  } catch (e) {
    variants = {};
  }

  var openBtn   = root.querySelector('.restock__open');
  var done      = root.querySelector('.restock__done');
  var doneText  = root.querySelector('.restock__done-text');
  var cancelBtn = root.querySelector('.restock__cancel');
  var noticeEl  = root.querySelector('.restock__notice');

  var current = null;          // 今選ばれているバリエーション {id, sku, title, available, backorder}
  var registered = {};         // このページで登録済みのSKU → {message, token}

  /* --- モーダル(global.js が body 直下へ移すので id で探す) --------------------- */
  function modal() { return document.getElementById(root.dataset.modal); }
  function inModal(sel) { var m = modal(); return m ? m.querySelector(sel) : null; }

  /* --- 置き場所を「売り切れ」ボタンの直後に移す --------------------------- */
  function relocate() {
    var buttons = document.querySelector('product-form .product-form__buttons');
    if (buttons && buttons.nextSibling !== root) {
      buttons.parentNode.insertBefore(root, buttons.nextSibling);
    }
  }

  /* --- 今のバリエーションを読む ------------------------------------------- */
  function readCurrentFromInput() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!input) return null;
    var v = variants[String(input.value)];
    if (!v) return null;
    return { id: String(input.value), sku: v.sku || '', title: v.title || '', available: !!v.available, backorder: !!v.backorder };
  }

  function render() {
    // 出すのは「売り切れ」か「取り寄せ中(在庫0で注文は受ける)」のとき。在庫あり・バリエーション未選択・SKUなし → 出さない
    if (!current || !current.sku || (current.available && !current.backorder)) {
      root.hidden = true;
      return;
    }
    root.hidden = false;
    noticeEl.hidden = true;
    // バリエーションが1つだけの商品は title が空(Liquidが "Default Title" を空にしている)。その場合は商品名を出す
    var nameEl = inModal('.restock__variant-name');
    if (nameEl) nameEl.textContent = current.title || root.dataset.productTitle || current.sku;
    if (registered[current.sku]) {
      doneText.textContent = registered[current.sku].message;
      cancelBtn.hidden = !registered[current.sku].token;
      done.hidden = false;
      openBtn.hidden = true;
    } else {
      done.hidden = true;
      openBtn.hidden = false;
    }
  }

  function update(variant) {
    if (variant && variant.id) {
      var v = variants[String(variant.id)] || {};
      current = {
        id: String(variant.id),
        sku: variant.sku || v.sku || '',
        title: variant.title || v.title || '',
        available: typeof variant.available === 'boolean' ? variant.available : !!v.available,
        backorder: !!v.backorder
      };
    } else {
      current = readCurrentFromInput();
    }
    render();
  }

  function showNotice(msg) {
    noticeEl.textContent = msg;
    noticeEl.hidden = false;
  }

  /* --- 訪問者ID(GA4の _ga クッキー) ---------------------------------------- */
  function gaClientId() {
    var m = document.cookie.match(/(?:^|;\s*)_ga=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* --- モーダルの表示切替(フォーム／完了) ------------------------------------ */
  function setModalView(view) {
    var f = inModal('.restock__form');
    var d = inModal('.restock__modal-done');
    if (f) f.hidden = (view === 'done');
    if (d) d.hidden = (view !== 'done');
  }

  function openModal() {
    var m = modal();
    if (!m || !current) return;
    var err = inModal('.restock__error');
    if (err) err.hidden = true;
    setModalView('form');
    if (typeof m.show === 'function') {
      m.show(openBtn);
    } else {
      m.setAttribute('open', '');
    }
    setTimeout(function () {
      var input = inModal('.restock__input');
      if (input) input.focus();
    }, 50);
  }

  function closeModal() {
    var m = modal();
    if (!m) return;
    if (typeof m.hide === 'function') {
      m.hide();
    } else {
      m.removeAttribute('open');
    }
  }

  /* --- 登録 ------------------------------------------------------------------ */
  function showError(msg) {
    var err = inModal('.restock__error');
    if (!err) return;
    err.textContent = msg;
    err.hidden = false;
  }

  function submit() {
    if (!current) return;
    var emailEl = inModal('.restock__input');
    var hpEl = inModal('.restock__hp');
    var submitBtn = inModal('.restock__submit');
    if (!emailEl || !submitBtn) return;
    var email = (emailEl.value || '').trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showError('メールアドレスの形式をご確認ください。');
      emailEl.focus();
      return;
    }
    var err = inModal('.restock__error');
    if (err) err.hidden = true;
    submitBtn.disabled = true;
    submitBtn.classList.add('restock__submit--loading');

    var body = new URLSearchParams();
    body.set('store', root.dataset.store);
    body.set('handle', root.dataset.handle);
    body.set('sku', current.sku);
    body.set('email', email);
    body.set('variant', current.title);
    body.set('product_title', root.dataset.productTitle || '');
    body.set('visitor_id', gaClientId());
    body.set('notify_on', current.backorder ? 'stock' : 'any'); // 取り寄せ中の登録は「在庫が入ったときだけ」
    body.set('website', hpEl ? (hpEl.value || '') : '');

    fetch(root.dataset.api, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: body.toString()
    })
      .then(function (res) { return res.json().catch(function () { return { ok: false }; }); })
      .then(function (data) {
        if (data && data.ok) {
          var msg = data.message || '再入荷次第、メールをお送りします。';
          registered[current.sku] = { message: msg, token: data.cancel_token || '' };
          var mdText = inModal('.restock__modal-done-text');
          if (mdText) mdText.textContent = msg;
          setModalView('done');
          render(); // 商品ページ側もその場で完了表示に
        } else {
          showError((data && data.error) || '登録できませんでした。時間をおいてもう一度お試しください。');
        }
      })
      .catch(function () {
        showError('通信に失敗しました。時間をおいてもう一度お試しください。');
      })
      .finally(function () {
        submitBtn.disabled = false;
        submitBtn.classList.remove('restock__submit--loading');
      });
  }

  /* --- 登録の取消(商品ページ側の完了表示の中のリンク) ----------------------- */
  cancelBtn.addEventListener('click', function () {
    if (!current || !registered[current.sku] || !registered[current.sku].token) return;
    if (!confirm('この商品の再入荷お知らせの登録を取り消しますか？')) return;
    var sku = current.sku;
    cancelBtn.disabled = true;
    fetch(root.dataset.cancelApi + '?t=' + encodeURIComponent(registered[sku].token) + '&json=1', { method: 'GET' })
      .then(function (res) { return res.json().catch(function () { return { ok: false }; }); })
      .then(function (data) {
        if (data && data.ok) {
          delete registered[sku];
          if (current && current.sku === sku) {
            render();
            showNotice('登録を取り消しました。');
          }
        } else {
          showNotice((data && data.message) || '取り消せませんでした。時間をおいてもう一度お試しください。');
        }
      })
      .catch(function () {
        showNotice('通信に失敗しました。時間をおいてもう一度お試しください。');
      })
      .finally(function () { cancelBtn.disabled = false; });
  });

  /* --- 操作 ------------------------------------------------------------------ */
  openBtn.addEventListener('click', openModal);

  // モーダル内のボタンは body 直下に移動した後に付ける(移動は global.js の connectedCallback で同期的に起きる)
  function bindModal() {
    var m = modal();
    if (!m || m.dataset.restockBound) return;
    m.dataset.restockBound = '1';
    var submitBtn = inModal('.restock__submit');
    var emailEl = inModal('.restock__input');
    var closeBtn = inModal('.restock__modal-close');
    if (submitBtn) submitBtn.addEventListener('click', submit);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (emailEl) {
      emailEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          submit();
        }
      });
    }
  }

  /* --- バリエーション切り替えを聞く ---------------------------------------- */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data ? event.data : {};
      if (data.sectionId && data.sectionId !== root.dataset.section) return;
      update(data.variant || null);
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest('variant-selects, variant-radios')) {
      setTimeout(function () { update(null); }, 80);
    }
  });

  /* --- 初期化 ---------------------------------------------------------------- */
  function init() {
    relocate();
    bindModal();
    update(null);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
